export const isDataUrl = input => /^data:/.test(input);
